import React from 'react';
import PropTypes from 'prop-types';

const PartnerLogo = ({ partner }) => {
  if (!partner) return null;
  const { url, logo, height, width, name } = partner;
  return (
    <a
      target="_blank"
      rel="noopener noreferrer"
      href={url}
    >
      <img src={logo} height={height} width={width} alt={name} />
    </a>
  );
};

PartnerLogo.propTypes = {
  partner: PropTypes.shape({
    url: PropTypes.string,
    logo: PropTypes.node,
    name: PropTypes.string,
    width: PropTypes.number,
    height: PropTypes.number
  }).isRequired
};

export default PartnerLogo;



// WEBPACK FOOTER //
// ./src/components/partner-logo/index.js